<template>
	<div class="taskGroupList">
		<el-table :data="taskGroupCurrent" @row-dblclick="rowDbclick" @current-change="handleCurrentChange" highlight-current-row rowKey="ID" :height="listHeight" @row-contextmenu="rowContextmenu" v-contextmenu:contextmenu>
			<el-table-column v-for="(column,index) in columns" :key="index" :prop="column.value" :label="column.text" :width="column.width">
				<template slot-scope="scope">
						        <i v-if="column.value==='INSTANCE'" :class="[{iconfont:true},scope.row.HasSub ? 'icon-weibiaoti5' : 'icon-renwu5']"></i>
							<span v-else>{{scope.row[column.value] }}</span>
</template>
			</el-table-column>
		</el-table>
    <v-contextmenu ref="contextmenu">
      <v-contextmenu-item @click="open()">打开</v-contextmenu-item>
      <v-contextmenu-item @click="handleFolderMenuClick()">详情</v-contextmenu-item>
    </v-contextmenu>
		<TaskDetails ref="taskDetail"></TaskDetails>
	</div>
</template>
<script>
	import TaskDetails from "./TaskDetails.vue";
	import {
		mapState,
		mapActions,
		mapMutations,
		mapGetters
	} from 'vuex'
	export default {
		name: "taskGroupList",
		components: {
			TaskDetails
		},
		props: {},
		data() {
			return {
        contextmenuRow: {},
				resizeTimer: null, // 自适应高度的定时器
				expandAll: false, // 表格是否展开
				selectedRow: null, // 当前选择的行的数据
				listHeight: window.innerHeight ||
					document.documentElement.clientHeight ||
					document.body.clientHeight - 1000, //（这里的240是减去表格上面导航和搜索条件的高度）
				columns: [ // 列
					{
						text: "任务",
						value: "INSTANCE"
					},
					{
						text: "任务类型",
						value: "TASKTYPENAME",
						width: 200
					},
					{
						text: "执行状态",
						value: "TASKSTATENAME"
					},
					{
						text: "任务名称",
						value: "TASKNAME"
					},
					{
						text: "创建人",
						value: "CREATEUSERNAME"
					},
					{
						text: "创建时间",
						value: "CREATETIME"
					},
					{
						text: "执行人",
						value: "EXCUTEUSERNAME"
					}
				]
			}
		},
		computed: {
			...mapState({
				taskGroupCurrent: state => state.task.taskGroupCurrent,
				taskGroupList: state => state.task.taskGroupList,
				taskGroupNative: state => state.task.taskGroupNative,
				taskGropuParent: state => state.task.taskGropuParent,
			}),
		},
		methods: {
			timeFormat(time) { // 时间格式化
				return time.substring(0, 19).replace("T", " ");
			},
			handleCurrentChange(row) { // 选中行数据
				this.$emit("changeCurTask", row);
			},
			rowDbclick(row, event) {
				// //双击行事件
				// this.$store.dispatch("changeCurTask", row);
				// this.$refs.taskDetail.dialogVisible = true;
				//双击行事件
				if (row.HasSub) {
					this.$store.commit("setTaskGroupCurrent", row.ID);
				} else {
					this.$store.dispatch("changeCurTask", row);
					this.$refs.taskDetail.dialogVisible = true;
				}
      },
      dbclick(row) {
        //双击行事件
        if (row.HasSub) {
          this.$store.commit("setTaskGroupCurrent", row.ID);
        } else {
          this.$store.dispatch("changeCurTask", row);
          this.$refs.taskDetail.dialogVisible = true;
        }
      },
      rowContextmenu(row, column, event) {
				this.contextmenuRow = row;
      },
      open() {
        this.dbclick(this.contextmenuRow);
      },
      handleFolderMenuClick() {
        this.$store.dispatch("changeCurTask", this.contextmenuRow);
        this.$refs.taskDetail.dialogVisible = true;
      }
		}
	}
</script>
<style scoped lang="less">
	@keyframes treeTableShow {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
	@-webkit-keyframes treeTableShow {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
	.sonTaskColor {
		color: #FFB84B;
	}
	.NameHighLight {
		cursor: pointer;
		color: #46A1FF;
	}
	.ms-tree-space {
		position: relative;
		top: 1px;
		display: inline-block;
		font-style: normal;
		font-weight: 400;
		line-height: 1;
		width: 18px;
		height: 14px;
	}
	.ms-tree-space::before {
		content: "";
	}
	.processContainer {
		width: 100%;
		height: 100%;
	}
	table td {
		line-height: 26px;
	}
	.tree-ctrl {
		position: relative;
		cursor: pointer;
		color: #2196f3;
		margin-left: -18px;
		margin-right: 5px;
	}
</style>
